//messages.js
export default {
    // Left nav menu
    general: "General",
    dashboard: "Tablero",
    customers: "Clientes",
    customer: "Cliente",
    user_tokens: "Tokens de Usuario",
    people: "Personas",
    devices: "Dispositivos",
    subscriptions: "Suscripciones",
    support: "Apoyo",
    service_tickets: "Tickets de Servicio",
    rma: "RMA",
    work_orders: "Órdenes de Trabajo",
    notifications: "Notificaciones",
    configuration: "Configuración",
    settings: "Configuraciones",
    mysql: "MySQL",

    additional_details: "Detalles Adicionales",

    email_add_front: "Una vez válido, presione",
    enter_key: "Enter",
    email_add_end: "para agregar un nuevo correo electrónico.",
    no_results_matching: "No hay resultados coincidentes",
    select_mod_lang: "Seleccione un módulo para ver y el idioma para traducir",
    select_email: "Seleccionar Correo Electrónico",
    select_caps: "SELECCIONE",
    has_user_account: "Inicio de sesión habilitado",
    no_users_available: "No Hay Usuarios Disponibles",
    no_devices_available: "No Hay Dispositivos Disponibles",
    add_permission: "Agregar permiso",
    editPermission: "Editar permiso",
    edit_language: "Seleccione un idioma para editar",
    language_properties: "Seleccione un idioma para ver sus propiedades",
    userProfile: "Mi Perfil",
    userAddresses: "Mis Direcciones",
    userPhones: "Mis Números de Teléfono",
    userEmails: "Mis Correos",
    userOrganizations: "Mis Organizaciones",
    notificationSettings: "Configuración de Notificaciones",
    commissions: "Comisiones",
    sensors: "Sensores",
    temperature: "Temperatura",
    overview: "Descripción General",
    dashboardOverview: "Descripción General del Panel",
    help: "Centro de Conocimiento",
    user: "Usuario",
    save: "Guardar",
    submit: "Enviar",
    submit_information: "Enviar Información",
    clear: "Despejar",
    continue: "Continuar",
    cancel: "Cancelar",
    collapse: "Colapso",
    reload: "Recargar",
    close: "Cerca",
    add: "Agregar",
    logOut: "Cerrar Sesión",
    search: "Buscar",
    default: "Predeterminado",
    loginNow: "Iniciar Sesión",
    createAccount: "Regístrese Ahora",
    getStarted: "Comenzar",
    dontHaveAn: "¿No tengo un",
    accountYet: "cuenta todavía?",
    termsOfService: "Condiciones de Servicio",
    privacyPolicy: "Política de Privacidad",
    bySigningUpYouAgreeTo: "Al registrarse, está indicando que ha leído y está de acuerdo con las",
    and: "y",
    helpEngineersContractors: "ayuda a ingenieros, contratistas, prefabricadores y laboratorios de pruebas a simplificar su proceso de monitoreo de concreto.",
    loginToAdmin: "Iniciar Sesión",
    enterUsernameAndPasswordToAccessControlPanelOf: "Ingrese nombre de usuario y contraseña para acceder al panel de control de",
    havingAnAccount: "¿Ya tienes una cuenta?",
    QuickLinks: "Enlaces Rápidos",
    toggle: "Alternar",
    yes: "Sí",
    no: "No",
    ok: "Bien",
    users_profile: "Perfil de Usuario",
    change_password: "Cambiar Contraseña",
    current_password: "Contraseña Actual",
    new_password: "Nueva Contraseña",
    confirm_password: "Confirmar Contraseña",
    my_addresses: "Mis Direcciones",
    my_phones: "Mis Teléfonos",
    my_emails: "Mis Correos Electrónicos",
    my_notifications: "Mis Notificaciones",
    activeUsers: "Usuarios Activos",
    active: "Activo",
    inactive: "Inactivo",
    add_new: "Agregar Nuevo",
    addNew: "Agregar Nuevo",
    refresh: "Actualizar",
    readMore: "Leer Más",
    assignNow: "Asignar Ahora",
    new: "Nuevo",
    pending: "Pendiente",
    update: "Actualizar",
    back: "Atras",
    name: "Nombre",
    email: "Correo Electrónico",
    editMember: "Editar Miembro",
    title: "Título",
    fullScreen: "Pantalla Completa",
    apply: "Aplicar",
    noItemsFound: "No se Encontraron Elementos",
    devicesShare: "Dispositivos Vompartidos",
    device_profile: "Perfil de Dispositivo",
    customerOverview: "Descripción General del Cliente",
    editUser: "Editar Usuario",
    addNewUser: "Agregar Nuevo Usuario",
    RecentUsers: "Usuarios Recientes",
    RecentComments: "Comentarios Recientes",
    RecentNotifications: "Notificaciones Recientes",
    messages: "Mensajes",
    english: "Inglés",
    edit: "Editar",
    activity: "Actividad",
    message: "Mensaje",
    itsFree: "¡Es gratis!",
    signUp: "Crear Cuenta",
    login: "Iniciar Sesión",
    signInNow: "Iniciar sesión ahora",
    forgotPassword: "Contraseña olvidada",
    resetPassword: "Restablecer contraseña",
    backToSignIn: "Volver para iniciar sesión",
    forgotyourPassword: "¿Olvidaste tu contraseña?",
    enterYourCellToSendYouAResetLink:
        "No hay problema, te ayudaremos a restablecerlo. Simplemente ingrese su número de teléfono móvil para recibir un enlace de reinicio",
    pleaseEnterYourPasswordToReset:
        "Introduzca una nueva contraseña. Su nueva contraseña debe contener al menos 8 caracteres, 1 mayúscula, 1 número y 1 símbolo.",
    deviceLog: "Registro del Dispositivo",
    confirm_delete_header: "¿Está seguro de que desea eliminar?",
    confirm_delete_message: "¿Está seguro de que desea eliminar?",
    confirmDelete: "¡Esta acción no es reversible!",
    delete_address: "¡Esto eliminará esta dirección de forma permanente!",
    delete_number: "¡Esto eliminará este número de teléfono de forma permanente!",
    delete_email: "¡Esto eliminará esta dirección de correo electrónico de forma permanente!",
    addPerson: "Agregar Persona",
    addCustomer: "Agregar Cliente",
    addDeviceBulk: "Agregar Dispositivos Masivos",
    editDevice: "Editar Dispositivo",
    addModule: "Agregar Módulo",
    editModule: "Editar Módulo",
    addCompany: "Agregar Empresa",
    removeCompany: "Eliminar Empresa",
    addPermission: "Agregar Permiso",
    editPermission: "Editar Permiso",
    addPermissionTo: "Agregar Permiso A",
    customer_name: "Nombre del Cliente",
    customer: "Cliente",
    addNumber: "Agregar Número",
    editNumber: "Editar Número",
    addEmail: "Agregar Correo Electrónico",
    editEmail: "Editar Correo Electrónico",
    addAddress: "Agregar Dirección",
    editAddress: "Editar Dirección",
    addPhone: "Agregar Teléfono",
    editPhone: "Editar Teléfono",

    api_access_id: "ID de Acceso API",
    key: "Llave",
    all_access: "Todo el Acceso",
    controller: "Controlador",
    deleded: "Eliminado",
    delete: "Eliminar",
    created_by: "Creado Por",
    last_updated_by: "Última Actualización Por",
    last_modified_by: "Última Modificación Por",
    deleted_by: "Eliminado Por",
    date_created: "Fecha de Creación",
    date_modified: "Fecha de Modificación",
    date_deleted: "Fecha de Eliminación",
    token_id: "ID de Token",
    access_token: "Token de Acceso",
    account_id: "Cuenta",
    session_data: "Datos de Sesión",
    api_keys_id: "Claves de API",
    companies: "Empresas",
    api_key: "Clave de API",
    level: "Nivel",
    ignore_limits: "Ignorar Límites",
    is_private_key: "Es Clave Privada",
    ip_addresses: "Direcciones Ip",
    id: "ID",
    uri: "Uri",
    count: "Cuenta",
    hour_started: "Hora de Inicio",
    method: "Método",
    params: "Params",
    time: "Tiempo",
    rtime: "Rtime",
    authorized: "Autorizado",
    response_code: "Código de Respuesta",
    ckey: "Ckey",
    citem: "Citem",
    config_type: "Tipo de Configuración",
    language_id: "Idioma",
    language: "Idioma",
    languages: "Idiomas",
    status: "Estado",
    status_id: "Estado",
    line_id: "Línea",
    key_id: "Clave",
    lang_text: "Texto en Idioma",
    module: "Módulo",
    lang_key: "Clave de Idioma",
    login_type_id: "Tipo de Inicio de Sesión",
    login_type: "Tipo de Inicio de Sesión",
    control_panel_id: "Panel de Control",
    primary_navigation: "Navegación Principal",
    timestamp: "Marca de Tiempo",
    data: "Datos",
    company: "Empresa",
    company_short: "Empresa Corta",
    website: "Sitio Web",
    correspondence_method: "Método de Correspondencia",
    correspondence_method_mail: "Método de Correspondencia: Correo",
    correspondence_method_electronic: "Método de Correspondencia: Electrónico",
    tax_id_number: "Número de Identificación Fiscal",
    credit_terms: "Condiciones de Crédito",
    currency_code: "Código de Moneda",
    credit_status: "Estado de Crédito",
    credit_limit: "Límite de Crédito",
    notes: "Notas",
    logo: "Logo",
    parent_id: "Padre",
    account_number: "Número de Cuenta",
    nick_name: "Apodo",
    account_nickname: "Nombre de Usuario de la Cuenta",
    account_type_id: "Tipo de Cuenta",
    import_id: "Importar",
    file_name: "Nombre de Archivo",
    entity_addresses_id: "Direcciones de Entidad",
    object_ref: "Referencia de Objeto",
    object_id: "Objeto",
    address1: "Dirección 1",
    address2: "Dirección 2",
    city: "Ciudad",
    state: "Estado",
    zip_code: "Código Postal",
    zip_code_ext: "Extensión de Código Postal",
    country_id: "País",
    address_type: "Tipo de Dirección",
    prime: "Prime",
    primary_caps: "PRIMARIO",
    primary: "Primario",
    entity_emails_id: "Correos Electrónicos de Entidad",
    email_type: "Tipo de Correo Electrónico",
    email_address: "Dirección de Correo Electrónico",
    primary_email_address: "Dirección de Correo Electrónico Principal",
    entity_life_events_id: "Eventos de Vida de la Entidad",
    event_type: "Tipo de Evento",
    select_a_language_to_edit: "Idioma de Filtro",
    update_title: "Título de actualización",
    update_article: "Actualizar artículo",
    save_articles: "Guardar nuevos artículos",
    confirm_remove_article: "¿Está seguro de que desea eliminar este artículo?",
    removeArticle: "Eliminar Artículo",
    event_date: "Fecha del Evento",
    reminder: "Recordatorio",
    reminder_interval: "Intervalo de Recordatorio",
    reminder_interval_type: "Tipo de Intervalo de Recordatorio",
    entity_phones_id: "Teléfonos de Entidad",
    phone_type: "Tipo de Teléfono",
    phone_code_id: "Código de Teléfono",
    phone_number: "Número de Teléfono",
    phone_extension: "Extensión de Teléfono",
    device_id: "Dispositivo",
    version: "Versión de Firmware",
    change_log: "Cambio de Registro",
    battery_full: "Batería Llena",
    battery_empty: "Batería Vacía",
    device_log_id: "Registro del Dispositivo",
    battery: "Batería",
    signal_quality: "Calidad de la Señal",
    signal: "Señal",
    queued_records: "Registros En Cola",
    queued: "En Cola",
    low: "Bajo",
    high: "Alta",
    avg: "Promedio",
    elapsed_time: "Tiempo Transcurrido",
    power_mode: "Modo de Energía",
    device_start: "Inicio del Dispositivo",
    device_end: "Fin del Dispositivo",
    sim: "Sim",
    imei: "IMEI / MEID",
    sensor_data: "Datos del Sensor",
    device_ports_id: "Puertos de Dispositivo",
    port_number: "Número de Puerto",
    sensor_type_id: "Tipo de Sensor",
    last_measurement: "Última Medición",
    public_id: "Id público",
    app_organisation_id: "Organización de la Aplicación",
    mobile_provider_id: "Proveedor Móvil",
    device_type: "Tipo de Dispositivo",
    purchase_date: "Fecha de Compra",
    warranty_period: "Periodo de Garantía",
    record_interval: "Intervalo de Grabación",
    upload_interval: "Intervalo de Carga",
    interval: "Intervalo",
    last_read: "Última Lectura",
    last_record_date: "Fecha del Último Registro",
    command: "Comando",
    project_id: "Proyecto",
    structure: "Estructura",
    client_name: "Nombre del Cliente",
    project_name: "Nombre del Proyecto",
    job_number: "Número de Trabajo",
    sensor_type: "Tipo de Sensor",
    sensor_description: "Descripción del Sensor",
    measurement_symbol: "Símbolo de Medición",
    imperial_symbol: "Símbolo Imperial",
    metric_symbol: "Símbolo Métrico",
    round_precision: "Precisión Redonda",
    subscription_id: "Id de Suscripción",
    transaction_id: "Id de Transacción",
    transaction_amount: "Monto de la Transacción",
    device_seats: "Asientos del Dispositivo",
    expire_date: "Fecha de Vencimiento",
    region_id: "Región",
    country_name: "Nombre del País",
    country_iso_2: "Country Iso 2",
    country_iso_3: "Country Iso 3",
    num_code: "Código Numérico",
    phone_code: "Código de Teléfono",
    iso: "Iso",
    nicename: "Nicename",
    iso3: "Iso3",
    numcode: "Numcode",
    phonecode: "Código de Teléfono",
    postal_code_id: "Código Postal",
    postal_code: "Código Postal",
    gps_lat: "Gps Lat",
    gps_lng: "Gps Lng",
    state_id: "Estado",
    county: "Condado",
    postal_class: "Clase Postal",
    region_name: "Nombre de la región",
    region_iso_2: "Región Iso 2",
    region_iso_3: "Región Iso 3",
    state_name: "Nombre del Estado",
    state_abbrv: "State Abbrv",
    login: "Iniciar Sesión",
    reason: "Razón",
    average: "Promedio",
    mobile_provider: "Proveedor Móvil",
    notification_object_id: "Objeto de Notificación",
    notification_name: "Nombre de Notificación",
    event: "Evento",
    module_name: "Nombre del Módulo",
    function_name: "Nombre de la Función",
    field_updated: "Campo Actualizado",
    custom_where: "Dónde Personalizado",
    timing: "Sincronización",
    icon: "Icono",
    max_attempts: "Intentos Máximos",
    email_msg: "Mensaje de Correo Electrónico",
    text_msg: "Mensaje de Texto",
    feed_msg: "Feed Msg",
    notification_queue_id: "Cola de Notificaciones",
    subject: "Asunto",
    accepted: "Aceptado",
    icon_class: "Clase de Icono",
    sent: "Enviado",
    hidden: "Oculto",
    sms_log_id: "Registro de SMS",
    message_id: "Mensaje",
    api_message_id: "Mensaje de API",
    error_code: "Código de Error",
    error: "Error",
    error_description: "Descripción del Error",
    phone_numbers: "Números de Teléfono",
    notification_to_people_id: "Notificación a las Personas",
    people_id: "Personas",
    notification_type_id: "Tipo de Notificación",
    notification_type: "Tipo de Notificación",
    Notifications_id: "Notificaciones",
    object_link: "Enlace de Objeto",
    read_flag: "Leer Bandera",
    sent_flag: "Bandera Enviada",
    alert_method: "Método de Alerta",
    smtp_log: "Registro de Smtp",
    option_id: "Opción",
    category_id: "Categoría",
    option: "Opción",
    value: "Valor",
    category: "Categoría",
    prefix: "Prefijo",
    first_name: "Primer Nombre",
    middle_name: "Segundo Nombre",
    last_name: "Apellido",
    suffix: "Sufijo",
    Combined_name: "Nombre Combinado",
    nick_name: "Apodo",
    job_title: "Título del Trabajo",
    gender: "Género",
    photo: "Foto",
    user_time_zone: "Zona Horaria",
    unit_of_measure: "Unidad de Medida",
    theme: "Tema",
    notification_method: "Método de Notificación",
    link_id: "Enlace",
    permission_role_id: "Rol de Permiso",
    people_to_contact_categories_id: "Categorías de Contactos de Personas",
    contact_category_id: "Categoría de Contacto",
    object: "Objeto",
    account_type: "Tipo de Cuenta",
    field_id: "Campo",
    fieldname: "Nombre de Campo",
    tablename: "Nombre de la Tabla",
    function_id: "Función",
    permission: "Permiso",
    permission_token: "Token de Permiso",
    module_id: "Módulo",
    exempt: "Exento",
    functions_to_privileges_id: "Funciones a Privilegios",
    privilege_id: "Privilegio",
    display_name: "Nombre para Mostrar",
    privilege: "Privilegio",
    privileges_to_roles: "Privilegios para Roles",
    role_id: "Rol",
    role: "Rol",
    table_id: "Tabla",
    position: "Posición",
    alias: "Alias",
    placeholder: "Placeholder",
    placeholder_word_phrase: "Escriba la palabra o frase de búsqueda...",
    rules: "Reglas",
    fillable: "Rellenable",
    protected: "Protegido",
    is_hidden: "Está oculto",
    is_searchable: "Se Puede Buscar",
    type: "Tipo",
    input_type: "Tipo de Entrada",
    length: "Largo",
    default_value: "Valor Predeterminado",
    attributes: "Atributos",
    index_type: "Tipo de Índice",
    aggregate: "Agregado",
    comments: "Comentarios",
    date_sync: "Sincronización de Fecha",
    relation_id: "Relación",
    related_type: "Tipo de Relación",
    reference_column_id: "Columna de Referencia",
    foreign_object_name: "Nombre de Objeto Extraño",
    foreign_model_name: "Nombre de Modelo Externo",
    is_user_def: "Es Definido por el Usuario",
    table_name: "Nombre de la Tabla",
    user_field_id: "Campo de Usuario",
    access_control: "Control de Acceso",
    user_function_id: "Función de Usuario",
    deny: "Negar",
    user_privilege_id: "Privilegio de Usuario",
    GRANTEE: "GARANTÍA",
    TABLE_CATALOG: "CATALOGO DE MESA",
    PRIVILEGE_TYPE: "TIPO DE PRIVILEGIO",
    IS_GRANTABLE: "ES GRANTABLE",
    user_role_id: "Rol de Usuario",
    token_object_id: "Objeto Ficha",
    object_name: "Nombre del Objeto",
    grant_by_user_id: "Otorgado por el Usuario",
    user_tracking_id: "ID de Seguimiento de Usuario",
    session_id: "ID de Sesión",
    request_method: "Método de Solicitud",
    function: "Función",
    post_data: "Publicar Datos",
    url: "Url",
    client_ip: "Ip del Cliente",
    user_agent: "Agente de Usuario",
    activate: "Activar",
    deactivate: "Desactivar",
    referer_page: "Página de Referencia",
    time_stamp: "Marca de Tiempo",
    username: "Nombre de Usuario",
    password: "Contraseña",
    default_account_id: "Cuenta Predeterminada",
    last_account_id: "Última Cuenta",
    default_calendar_id: "Calendario Predeterminado",
    activation_code: "Código de Activación",
    forgotten_password_code: "Código de Contraseña Olvidado",
    forgotten_password_time: "Hora de Contraseña Olvidada",
    remember_code: "Recordar Código",
    last_login: "Último Inicio de Sesión",
    users_to_accounts_id: "Usuarios a Cuentas",
    request_date: "Fecha de Solicitud",
    node_id: "ID de Nodo",
    addWO: "Agregar Orden de Trabajo",
    wo_number: "Número de Orden de Trabajo",
    wo_number_short: "WO #",
    wo_history: "Historial de Órdenes de Trabajo",
    return_address: "Dirección de Devolución",
    warranty_repair: "Reparación de Garantía",
    inbound_tracking_number: "Envíos Entrantes",
    reason_for_return: "Motivo de la Devolución",
    contact_name: "Nombre de Contacto",
    contact_phone: "Teléfono de Contacto",
    contact_email: "Correo Electrónico de Contacto",
    work_orders_profile: "Orden de trabajo",
    node_received: "Nodo Recibido",
    received: "Recibido",
    quoted: "Citado",
    approved: "Aprobado",
    confirm: "Confirmar",
    work_performed: "Trabajo Realizado",
    date_performed: "Fecha de Realización",
    performed_by: "Realizado Por",
    outbound_tracking_number: "Envíos Salientes",
    track: "Rastrear",
    printDialog: "Vista Previa",
    print: "Imprimir",
    printClose: "Cerrar",
    emailDialog: "Correo Electrónico",
    is_owner: "¿Este usuario es propietario de esta empresa?",
    is_owner_yes: "Es Propietario: Sí",
    is_owner_no: "Es Propietario: No",
    confirm_remove_beginning: "¿Está seguro de que desea eliminar",
    confirm_remove_end: "de este usuario?",
    save_changes: "Guardar cambios",
    undo_changes: "Deshacer",
    select_company: "Seleccione una empresa para ver sus permisos",
    select_a_company: "Seleccionar una empresa",
    send: "enviar",
    zoho_estimate_id: "Número de Estimación de Zoho",
    zoho_customer_id: "Id de Cliente de Zoho",
    zoho_total: "Total de Zoho",
    zoho_status: "Estado de Zoho",
    stripe_id: "Id de banda",
    requote: "Estimación de Recotización",
    clearNotifDialog: "Borrar Notificaciones",
    confirmClearNotif: "¿Está seguro de que desea marcar todas las notificaciones como leídas?",
    notifWarning: "ADVERTENCIA: ¡Esto no se puede deshacer!",
    readAll: "Marcar Todo Como Leído",
    permissions: "Permisos",
    help_articles: "Artículos de Ayuda",
    create_article: "Crear Artículo",
    translate_articles: "Traducir Artículos",
    create_notification: "Crear Notificación",
    object_link: "Enlace de Objeto",
    login_popup: "Ventana Emergente de Inicio de Sesión",
    notification_to: "Para",
    person: "Persona",
    firmware: "Firmware",
    firmware_filter_operator: "Filtro de Firmware",
    modifyCompany: "Modificar Empresa",
    uploadImage: "Subir Imagen",
    active_languages: "Idiomas Activos",
    create_articles: "Crear articulos",
    all: "Todo",
    no_devices: "No hay dispositivos asociados a esta cuenta.",
    no_devices_filter: "No hay dispositivos basados en el filtro.",
    active_only: "Solo Activo",
    no_permissions: "Este módulo no tiene permisos",
    select_module: "Seleccione un módulo para ver los permisos",
    permission_help: "Ayuda",
    notice: "AVISO",
    employee: "Empleado",
    distributor: "Distribuidor",
    home: "Hogar",
    mobile: "Móvil",
    work: "Trabajo",
    billing: "Facturación",
    shipping: "Envío",
    other: "Otro",
    f: "Fahrenheit",
    c: "Celsius",
    remove_company_from_user: "Eliminar empresa del usuario",
    modify_person: "Modificar Persona",
    required: "Requerido",
    required_zip_code: "El artículo debe tener al menos 5 números",
    required_email: "El correo electrónico debe ser válido",
    required_url: "La URL debe ser válida",
    create_article: "Crear Artículo",
    select_module: "Seleccione un módulo para ver sus artículos",
    no_articles_found: "No se encontraron artículos para",
    select_a_module: "Seleccionar un módulo",
    select_a_language: "Seleccionar un idioma",
    article_title: "Título del Artículo",
    write_article: "Escribe un nuevo artículo...",
    filter_modules: "Filtrar módulos",
    loading: "Cargando...",
    create_new_user: "Crear Nuevo Usuario",
    create_new_person: "Crear Nuevo Persona",
    manual: "Manual",
    new_user_form: "Formulario de Nuevo Usuario",
    do_not_show: "No mostrar de nuevo",
    view_all_notifications: "Ver Todas las Notificaciones",
    show_differentials: "Mostrar Diferenciales",
    hide_differentials: "Ocultar Diferenciales",
    new_person_form: "Formulario de Nueva Persona",
    invite: "Invitar",
    create_user_account_yes: "Crear Cuenta de Usuario: Sí",
    create_user_account_no: "Crear Cuenta de Usuario: No",
    invite_person: "Invitar Persona",
    invite_user: "Invitar Usuario",
    userInvite: "Usario Invitar",
    logarithmic: "Logarítmica",
    exponential: "Exponencial",
    hyperbolic: "Hiperbólica",
    suspended: "Suspendida",
    retired: "Retirada",
    demo: "Manifestación",
    normal: "Normal",
    one_year: "1 Año",
    year: "Año",
    interval_450: "1 Min (Solo Fines de Prueba)",
    interval_600: "10 Min",
    interval_4500: "10 Min",
    interval_6750: "15 Min",
    interval_9000: "20 Min",
    interval_13500: "30 Min",
    interval_27000: "60 Min",
    initializing: "Inicializando...",
    unassigned: "Sin Asignar",
    pause_caps: "PAUSA",
    live_caps: "EN VIVO",
    input_too_long: "La entrada es demasiado larga",
    breaks: "Rotura",
    required_ttf: "Debe seleccionar el modelo TTF",
    can_not_be_zero: "El elemento no puede ser 0",
    can_not_be_negative: "El artículo no puede ser negativo",
    value_too_high: "El valor es demasiado alto",
    none: "Ninguna",
    date_cast_caps: "FECHA DE REPARTO",
    activate_user_account: "Activar cuenta de usuario",
    add_new_article: "Agregar nuevo artículo",
    modify_person: "Modificar Persona",
    mobile_phone: "Teléfono Móvil",
    requested: "Solicitado",
    working: "Trabajando",
    closed: "Cerrado",
    wo_info: "Información de la Orden de Trabajo",
    date_requested: "Fecha Solicitada",
    inbound_tracking: "Seguimiento Entrante",
    outbound_tracking: "Seguimiento Saliente",
    track_inbound: "Seguimiento Entrante",
    track_outbound: "Seguimiento de Salida",
    history: "Historia",
    select_new_quote: "Debe seleccionar una nueva cotización",
    select_different_quote: "Debe seleccionar una cotización diferente",
    tracking: "Rastreo",
    weight: "Peso",
    activity_date: "Fecha de Actividad",
    modules: "Módulos",
    get: "Obtener",
    put: "Poner",
    patch: "Parche",
    post: "Enviar",
    filter: "Filtrar",
    group: "Grupo",
    marketing: "Márketing",
    tokens: "Tokens",
    equal_to: "Igual A",
    less_than: "Menos Que",
    greater_than: "Mas Grande Que",
    less_than_or_equal_to: "Menos Que o Igual A",
    greater_than_or_equal_to: "Mayor Qué o Igual A",
    configuration: "Configuración",
    must_select_option: "Debe seleccionar la opción",
    must_select_at_least_one: "Debe seleccionar al menos una opción",
    number_email_required: "Se requiere el número de celular",
    number_email: "Número de Teléfono Móvil",
    request_reset: "Solicitar reinicio",
    check_for_instructions: "Consulte su correo electrónico o teléfono móvil para obtener instrucciones.",
    password_required: "Se requiere contraseña",
    remember_me: "Recuérdame",
    valid_username: "El nombre de usuario debe ser válido",
    open: "Abierto",
    Delivered: "Entregado",
    number: "Número",
    must_match: "Debe coincidir con",
    passwords_must_match: "Las contraseñas deben coincidir",
    require_one_caps: "Debe tener al menos una letra mayúscula",
    require_one_lowercase: "Debe tener al menos una letra minúscula",
    require_one_number: "Debe ser al menos un número",
    require_one_special: "Debe tener al menos un carácter especial: !@#$%^&*",
    require_min_8: "Debe tener 8 o más caracteres",
    require_max_16: "Debe tener 16 caracteres o menos",
    require_max_100: "Debe tener 100 caracteres o menos",
    require_one_period: "Solo puede ser un período",
    require_one_at: "Solo puede ser un símbolo @",
    min_value_is: "Min es",
    min_length_is: "La longitud mínima es",
    max_value_is: "Max es",
    max_length_is: "La longitud máxima es",
    length_must_be: "La longitud debe ser",
    invalid_characters: "Caracteres inválidos",
    invalid_email_format: "Formato de correo inválido",
    add_new_seat: "Comprar asiento nuevo",
    checkout: "Revisa",
    require_letter_start: "Debe comenzar con una letra",
    account_creation_opening_info: "Complete la siguiente información lo antes posible. Solo tendrás 24 horas antes de que expire la invitación.",
    subscribe: "Suscribir",
    valid_username_required: "Se requiere un nombre de usuario válido",
    add_payment_method: "Añadir método de pago",
    select_payment_method: "Seleccione una forma de pago",
    select_payment_period: "Seleccione el período de pago",
    auto_renew: "Auto Renovación",
    primary_billing_email: "Correo electrónico de facturación principal",
    no_change_primary_billing_email: "Tenga en cuenta que la dirección de correo electrónico de facturación principal no se puede cambiar.",
    edit_subscription: "Editar Suscripción",
    cancel_subscription: "Cancelar Suscripción",
    issued: "Emitido",
    revoked: "Revocado",
    revoke: "Revocar",
    owner: "Propietario",
    create: "Crear",
    leave: "Salir",
    create_token: "Crear Token",
    confirm_leave_company: "¿Estás segura de que quieres dejar esta empresa?",
    access_tokens: "Tokens de Acceso",
    battery_profile: "Perfil de Batería",
    no_subscriptions_past_due: "Sin suscripciones vencidas",
    remove_card: "Quitar Tarjeta",
    update_default_card: "Actualizar Tarjeta Predeterminada",
    good: "Buena",
    medium: "Medio",
    poor: "Pobre",
    imperial: "Imperial",
    metric: "Métrica",
    active_sessions: "Sesiones Activas",
    subscription: "Suscripción",
    user_id: "ID de Usuario",
    select_a_session: "Seleccionar Sesión",
    active_session_delete_confirm: "¿Está seguro de que desea finalizar la sesión seleccionada?",
    active_sessions_delete_confirm: "¿Está seguro de que desea finalizar las sesiones seleccionadas?",
    delete_active_session: "Eliminar Sesión Activa",
    delete_active_sessions: "Eliminar Sesiones Activas",
    delete_all: "Eliminar todos",
    user_session: "'s Sesión",
    no_cards: "No hay tarjetas en el archivo",
    expires: "Expira",
    set_default: "Establecer por defecto",
    active_subscriptions: "Suscripciones Activas",
    buy_seats: "Comprar asientos",
    no_data: "No hay datos para mostrar",
    total: "Total",
    per_month: "por mes",
    per_year: "por año",
    name_on_card: "Nombre en la tarjeta",
    cardholder_email: "Correo electrónico del titular de la tarjeta",
    confirm_cancel_subscription:
        "¿Estás seguro de que deseas cancelar esta suscripción? Esta suscripción permanecerá activa hasta la próxima fecha de vencimiento. No se reembolsará el dinero.",
    subscription_plan: "Plan de suscripción:",
    amount_of_seats: "Cantidad de asientos:",
    price: "Precio",
    start_date: "Fecha de inicio:",
    end_date: "Fecha final:",
    invoice_id: "ID de factura:",
    confirm_remove_card: "¿Estás seguro de que quieres eliminar esta tarjeta?",
    make_default: "¿Quieres convertir este en tu método de pago predeterminado?",
    add_article: "Agregar artículo",
    edit_articles: "Editar artículos",
    search_dots: "Buscar...",
    knowledge_center: "Centro de Conocimiento",
    no_data_available: "Datos no disponibles",
    card_ending_in: "Tarjeta terminada en",
    greater_than_or_equal_to_one: "El elemento debe ser mayor o igual a 1",
    fill_all_card_info: "¡Complete toda la información de la tarjeta!",
    monthly: "Mensual",
    yearly: "Anual",
    fields: "Campos",
    relationships: "Relaciones",
    no_subscriptions: "No hay suscripciones actuales registradas",
    sensor_types: "Tipos de Sensores",
    add_sensor: "Agregar Sensor",
    edit_sensor: "Editar Sensor",
    delete_sensor: "¡Esto eliminará este tipo de sensor de forma permanente!",
    sync: "Sincronizar",
    add_firmware_version: "Agregar Firmware",
    edit_firmware_version: "Editar Firmware",
    delete_firmware_version: "Eliminar Versión de Firmware",
    battery_alerts_switch: "Alertas de Batería",
    login_attempts: "Intentos de Acceso",
    login_attempt: "Intento de Inicio de Sesión",
    edit_permissions: "Editar Permisos",
    save_article: "Guarda este artículo",
    delete_login_attempt: "¡Esto eliminará este intento de inicio de sesión de forma permanente!",
    battery_data: "No hay datos de batería disponibles",
    signal_data: "No hay datos de señal disponibles",
    device_code: "Código QR Del Dispositivo",
    get_code: "Generar Código QR",
    scan_code: "Escanear Código QR",
    choose_image: "Elige una imagen.",
    replace: "Reemplazar",
    mobile_phone_notification: "Número de Móvil para Notificaciones",
    email_address_notification: "Dirección de Correo Electrónico para Notificaciones",
    no_notifications: "No hay notificaciones para este usuario",
    change_view: "Cambio Vista",
    no_companies: "No se encontraron empresas",
    no_permission: "Permiso Denegado",
    no_permission_text: "No tienes permiso para realizar esta acción.",
    relationship: "Relación",
    countrySelectorLabel: "Código de país",
    countrySelectorError: "Elige país",
    phoneNumberLabel: "Número de teléfono",
    example: "e.g.",
    notify_oops: "Huy! Algo salió mal.",
    project_details: "Detalles del Proyecto",
    user_account: "Tiene Cuenta de Usuario",
    cancelled: "Cancelado",
    work_completed: "Trabajo Completado",
    session_timed_out: "Se agotó el tiempo de espera de la sesión",
    incorrect_value: "Valor incorrecto",
    permission_templates: "Plantillas de Permisos",
    no_work_orders: "Sin órdenes de Trabajo",
    select_login_type_base: "Seleccione un Tipo de Inicio de Sesión",
    select_login_type: "Seleccione un Tipo de Inicio de Sesión Para ver las Plantillas de Permisos",
    save_template: "Guardar Plantilla",
    apply_template: "Aplicar Plantilla",
    menu: "Menú",
    addToken: "Agregar Token",
    user_to_give_token: "Usuario para dar token",
    go_back: "Regresa",
    stripe_subscription_id: "ID de suscripción de Stripe",
    amount: "Monto",
    period_start: "Inicio del período",
    period_end: "Fin del período",
    no_articles_available: "No hay artículos disponibles en este módulo",
    return: "Regreso",
    click_to_activate: "Haga clic para activar",
    click_to_deactivate: "Haga clic para desactivar",
    complete: "Completo",
    receive_device: "Marcar dispositivo como recibido",
    date_last_updated: "Última actualización: ",
    void: "Vacío",
    current_wo_delete_confirm: "¿Está seguro de que desea anular la orden de trabajo actual? ¡Tenga en cuenta que no hay forma de revertir esto!",
    delete_wo: "Orden de trabajo nula",
    helpful: "Servicial",
    yes_helpful: "Esto fue útil",
    no_helpful: "Esto no fue de ayuda",
    new_request: "Nueva solicitud",
    in_progress: "En curso",
    open_extended: "Abierto extendido",
    parts_on_order: "Piezas bajo pedido",
    on_hold: "En espera",
    awaiting_info: "Esperando información",
    awaiting_funding: "En espera de financiación",
    deferred: "Diferido",
    call: "Llamada",
    display_shipping_info: "Datos de envío",
    recent_readings: "Lecturas recientes del dispositivo",
    remove_company: "Eliminar empresa",
    send_email: "Escribir correo",
    directions: "Direcciones",
    show_map: "Mostrar Mapa",
    username_not_avail: "Nombre de usuario no disponible",
    username_avail: "Nombre de usuario disponible",
    form_builder: "Constructor de Formularios",
    add_form_builder: "Agregar Formulario",
    form: "Formulario",
    forms: "Formularios",
    select_form: "Seleccionar Formulario",
    min_length: "Longitud Mínima",
    max_length: "Longitud Máxima",
    delete_form_message: "¿Está seguro de que desea eliminar este formulario?",
    delete_form_heading: "Eliminar Formulario",
    delete_form_field_message: "¿Está seguro de que desea eliminar este campo de formulario?",
    delete_form_field_heading: "Eliminar Campo de Formulario",
    delete_phone_for_notifications: "Esto detendrá las notificaciones que lleguen a este teléfono.",
    delete_email_for_notifications: "Esto detendrá las notificaciones que lleguen a este correo electrónico.",
    integer_required: "Entero Requerido",
    decimal_required: "Decimal Requerido",
    not_unique: "No Único",
    delete_entity_address: "Eliminar Dirección",
    delete_entity_phone: "Eliminar Teléfono",
    delete_entity_email: "Eliminar Correo Electrónico",
    new_primary_address: "Nueva Dirección Principal",
    new_primary_phone: "Nuevo Teléfono Principal",
    new_primary_email: "Nuevo Correo Electrónico Principal",
    text_copied: "Texto Copiado",
    tank_products: "Productos de tanque",
    delete_tank_product: "Eliminar producto de tanque",
    add_tank_product: "Agregar producto de tanque",
    edit_tank_product: "Editar producto de tanque",
    product_name: "Nombre del producto",
    specific_gravity: "Gravedad específica",
    total_active_sensors: "Sensores activos totales",
    total_sensors: "Sensores totales",
    entity_phone_details: "Detalles del Teléfono",
    entity_address_details: "Detalles de Dirección",
    entity_email_details: "Detalles del Correo Electrónico",
    tank_types: "Tipos de tanque",
    delete_tank_type: "Eliminar tipo de tanque",
    add_tank_type: "Agregar tipo de tanque",
    edit_tank_type: "Editar tipo de tanque",
    image_url: "URL de la imagen",
    tank_type: "Tipo de tanque",
    slug: "Slug",
    formula: "Fórmula",
    comments: "Comentarios",
    width: "Ancho",
    height: "Altura",
    diameter: "Diámetro",
    after_save_profile: "Después de Guardar: Ir al perfil",
    after_save_stay: "Después de Guardar: Quédese aquí",
    mobile_network: "Red Móvil",
    move_products: "Mover Productos",
    reprovision: "Reaprovisionamiento",
    delete_device: "Eliminar Dispositivo",
    monitor_device: "Monitorear el Dispositivo",
    reprovision_device:
        "¿Está seguro de que desea reaprovisionar este dispositivo? El reaprovisionamiento eliminará permanentemente todos los datos, incluido el historial del dispositivo.",
    device_identifier: "Identificador de Dispositivo",
    sim_provider: "Proveedor de SIM",
    term: "Término",
    renewal_date: "Fecha de Renovación",
    sim_paused: "Sim en Pausa",
    sim_activated: "Sim Activado",
    scan_again: "Escanea Otra Vez",
    surge_protection: "Protección Contra Sobretensiones",
    delete_qr_code: "Eliminar Código QR",
    no_cameras: "No se detectaron cámaras",
    configure_environment: "Configurar el Entorno",
    pref_cleared: "Preferencias Despejadas",
    credentials: "Cartas Credenciales",
    no_rear_camera: "No se detectó cámara trasera",
    no_front_camera: "No se detectó cámara frontal",
    switch_camera: "Cambiar de Cámara",
    delete_rfid: "Eliminar RFID",
    select_tags: "Seleccionar Etiquetas",
    has_front_camera: "Tiene cámara frontal",
    has_rear_camera: "Tiene cámara trasera",
    default_camera: "Cámara predeterminada",
    primary_login: "Inicio de sesión principal",
    front_camera_access: "Acceso a la cámara frontal",
    rear_camera_access: "Acceso a la cámara trasera",
    not_checked_for_camera: "No comprobado para cámara",
    clear_preferences: "PREFERENCIAS CLARAS",
    remove_access: "Quitar acceso",
    detect_enable: "DETECTAR / HABILITAR",
    detect: "DETECTAR",
    unknown: "DESCONOCIDO",
    auto: "AUTO",
    front: "Frontal",
    rear: "Trasera",
    tags: "Etiquetas",
    delete_tag: "Eliminar Etiqueta",
    add_tag: "Añadir Etiqueta",
    edit_tag: "Editar Etiqueta",
    tag: "Etiqueta",
    label: "Etiqueta",
    manage_tag: "Administrar Etiqueta",
    create_tag: "Crear Etiqueta",
    remove_tag: "Remover etiqueta",
    remove: "Quitar",
    confirm_remove_message: "¿Estás segura de que quieres eliminar?",
    attach_existing: "Adjuntar Existente",
    page_refreshed: "Página actualizada",
    delete_person: "Eliminar persona",
    on: "Sobre",
    off: "Apagada",
    all_companies: "Todas las Empresas",
    rescan: "Volver a Escanear",
    success: "Éxito",
    modify_device: "Modificar Dispositivo",
    add_port: "Agregar Puerto",
    delete_device_port: "Eliminar Puerto de Dispositivo",
    add_device_port: "Agregar Puerto de Dispositivo",
    edit_device_port: "Editar Puerto de Dispositivo",
    product_id: "Producto",
    tank_type_id: "Tipo de Tanque",
    reorder_yellow: "Reordenar Amarillo",
    reorder_red: "Reordenar Rojo",
    invalid_qr_or_no_access: "QR no válido o sin acceso",
    must_be_less_than: "Debe ser menor que",
    must_be_greater_than: "Debe ser mayor que",
    expiration_date: "Fecha de Caducidad",
    expiration_time: "Tiempo de Expiración",
    number_required: "Número Requerido",
    more: "Más",
    username_not_set: "Nombre de usuario no establecido",
    not_available: "No Disponible",
    settings_menu: "Menú de Configuración",
    tank_manufacturers: "Fabricantes de tanques",
    tank_manufacturer: "Fabricante de tanques",
    delete_tank_manufacturer: "Eliminar fabricante del tanque",
    add_tank_manufacturer: "Agregar fabricante de tanques",
    edit_tank_manufacturer: "Editar fabricante de tanques",
    manufacturer: "Fabricante",
    phone: "Teléfono",
    tank_manufacturers_specs: "Especificaciones de los Fabricantes de Tanques",
    delete_tank_manufacturers_spec: "Eliminar especificaciones de fabricantes de tanques",
    add_tank_manufacturers_spec: "Agregar especificaciones de fabricantes de tanques",
    edit_tank_manufacturers_spec: "Editar especificaciones de fabricantes de tanques",
    manufacturer_id: "Fabricante",
    tank_name: "Nombre del tanque",
    def_us_gallons: "Def Us Galones",
    metric_diameter: "Diámetro métrico",
    metric_height: "Altura métrica",
    metric_width: "Ancho métrico",
    metric_length: "Longitud métrica",
    development_mode: "Modo de Desarrollo",
    add_another_address: "Agrega otra dirección",
    location_label: "Etiqueta de ubicación",
    electronic: "Electrónico",
    mail: "Correo",
    view_all: "Ver todo",
    show_less: "Muestra menos",
    show_more: "Mostrar más",
    edit_widgets: "Editar Widgets",
    add_widgets: "Agregar Widgets",
    arrange_widgets: "Organizar Widgets",
    company_type: "Tipo de Empresa",
    add_note: "Añadir la Nota",
    note_details: "Detalles de la Nota",
    delete_note: "Borrar Nota",
    copy: "Copiar",
    specs: "Especificaciones",
    no_specs: "No hay especificaciones",
    add_spec: "Añadir especificación",
    edit_spec: "Editar especificación",
    contact_info: "Información de Contacto",
    request_info: "Solicitar Información",
    work_done: "Trabajo Realizado",
    address_copied: "Dirección Copiada",
    phone_number_copied: "Número de Teléfono Copiado",
    email_address_copied: "Dirección de Correo Electrónico Copiada",
    insert_image_view: "Insertar URL de imagen para ver",
    date: "Fecha",
    error_loading: "Error al cargar",
    device_number_short: "# Dispositivo",
    zoho_estimate_number_short: "# Estimación de Zoho",
    contact: "Contacto",
    date_completed: "Fecha Completada",
    not_done: "No hecho",
    attach_estimate: "Adjuntar Estimación",
    zoho_customer: "Cliente de Zoho",
    add_tank: "Agregar Tanque",
    edit_tank: "Editar Tanque",
    delete_tank: "Eliminar Tanque",
    tank_size: "Tamaño del Tanque",
    tank_width: "Ancho del Tanque",
    tank_diameter: "Diámetro del Tanque",
    tank_length: "Longitud del Tanque",
    tank_height: "Altura del Tanque",
    sensor_offset: "Desplazamiento del sensor",
    tank_number_short: "# Tanque",
    offset: "Desplazamiento",
    size: "Tamaño",
    select_tank_to_view: "Selecciona un tanque para ver",
    devices_linked: "Dispositivos vinculados",
    delete_port: "Eliminar Puerto",
    device_deleted: "Dispositivo eliminado",
    device_updated: "Dispositivo actualizado",
    edit_device: "Editar Dispositivo",
    offline_devices: "Dispositivos fuera de línea",
    WorkOrders: "Órdenes de trabajo",
    Subscriptions: "Suscripciones",
    RecentDataSessions: "Sesiones de datos recientes",
    RecentNotifications: "Notificaciones recientes",
    WeeklySales: "Ventas semanales",
};
